import React from "react";
import "./HouseingTransform.css";

const FrontOfficeTransform = () => {
  return (
    <section className="workplace-cta-section">
      <div className="workplace-cta-container">
        <h2 className="workplace-cta-title">
          Create the Perfect First Impression
        </h2>

        <p className="workplace-cta-text">
          Get professionally trained front office executives to represent your
          organization with excellence
        </p>

        <a
          href="https://wa.me/919899811123?text=Front%20Office%20Staffing"
          target="_blank"
          rel="noopener noreferrer"
          className="workplace-cta-btn"
        >
          Hire Front-Desk Staff →
        </a>
      </div>
    </section>
  );
};

export default FrontOfficeTransform;
